import React from 'react'

const ICON = {
    width: "16",
    height: "16",
    colors: {
        company: "#87D72A",
        candidate: "#0D7AB6"
    }
};

const IconTriangle = ({ position, iconType }) => {

    return(
        position === "left" ?
        <svg width={ICON.width} height={ICON.height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.0667 8L5 14.5L5 1.5L11.0667 8Z" fill={iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company} />
        </svg> :
        <svg width={ICON.width} height={ICON.height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.03333 11.0333L1.53333 4.96667L14.5333 4.96667L8.03333 11.0333Z" fill={iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company}/>
        </svg>
    )
};

export default IconTriangle;
